<template lang="pug">
    .stock-timeline
        LineChart(:dailydata="timelineData" :height="200")
</template>

<script>
import LineChart from './line-chart.vue';
import storeMixin from '../store/mixin';
import intervalMixin from './interval-mixin.vue';

export default {
    name: 'StockTimeline',
    mixins: [storeMixin, intervalMixin],
    components: { LineChart },
    props: { code: String },
    data() {
        return {
            base: 'v2/finance/stock/trade/minute/list',
            lines: null,
        };
    },
    computed: {
        url() {
            return `${this.base}?code=${this.code}`;
        },
        timelineData() {
            return (
                this.lines &&
                this.lines.map(item => {
                    return [item.trade_time * 1000, item.current, item.volume];
                })
            );
        },
    },
    watch: {
        code() {
            this.getList();
        },
    },
    created() {
        this.getList();
    },
    methods: {
        mixinIntervalMethods() {
            this.getList();
        },
        async getList() {
            if (!this.url) return cosnsole.error('url needed.');
            try {
                const result = await this.REQUEST({
                    url: `${this.url}`,
                });
                this.lines = result.data.items;
            } catch (e) {
                console.log(e);
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
*
    padding 0
</style>
